import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { defaults } from '../../environments/default';

const PENAL_AGE = defaults.rules.penalAge;
const minLength = defaults.rules.minLength;

export class FieldValidators {

  static onlyLetters(control: AbstractControl): ValidationErrors | null {
    const { value } = control;

    if (!value) {
      return null;
    }

    if (!value.match(/^[ A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02af\u1d00-\u1d25\u1d62-\u1d65\u1d6b-\u1d77\u1d79-\u1d9a\u1e00-\u1eff\u2090-\u2094\u2184-\u2184\u2488-\u2490\u271d-\u271d\u2c60-\u2c7c\u2c7e-\u2c7f\ua722-\ua76f\ua771-\ua787\ua78b-\ua78c\ua7fb-\ua7ff\ufb00-\ufb06]+$/)) {
      return { onlyLetters: true, message: 'Informe apenas letras' };
    }

    return null;
  }

  static postalCode(control: AbstractControl): ValidationErrors | null {
    const { value } = control;

    if (!value) {
      return null;
    }

    // eslint-disable-next-line no-useless-escape
    if (typeof value !== "string" || !/^[0-9]{5}\-?[0-9]{3}$/g.test(value)) {
      return { phone: true, message: 'CEP inválido' };
    }

    return null;
  }

  static phone(control: AbstractControl): ValidationErrors | null {




    const { value } = control;

    if (!value) {

      return null;

    }

    if (!(value.length >= 10 && value.length <= 11)) {

      return { phone: true, message: 'Telefone inválido' };

    }

    if (value.length == 11 && parseInt(value.substring(2, 3)) != 9)
      return { phone: true, message: 'Telefone inválido' };


    const codigosDDD = [11, 12, 13, 14, 15, 16, 17, 18, 19,
      21, 22, 24, 27, 28, 31, 32, 33, 34,
      35, 37, 38, 41, 42, 43, 44, 45, 46,
      47, 48, 49, 51, 53, 54, 55, 61, 62,
      64, 63, 65, 66, 67, 68, 69, 71, 73,
      74, 75, 77, 79, 81, 82, 83, 84, 85,
      86, 87, 88, 89, 91, 92, 93, 94, 95,
      96, 97, 98, 99];

    if (codigosDDD.indexOf(parseInt(value.substring(0, 2))) == -1)

      return { phone: true, message: 'Telefone inválido' };


    if (value.length == 10 && [2, 3, 4, 5, 7].indexOf(parseInt(value.substring(2, 3))) == -1)
      return { phone: true, message: 'Telefone inválido' };

    return null;



  }

  static email(control: AbstractControl): ValidationErrors | null {


    const { value } = control;

    if (!value) {
      return null;
    }

    if (typeof value !== "string" || Validators.email(control)) {
      return { email: true, message: 'E-mail inválido' };
    }

    const emailRegexp = new RegExp(
      /^[a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1}([a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1})*[a-zA-Z0-9]@[a-zA-Z0-9][-\.]{0,1}([a-zA-Z][-\.]{0,1})*[a-zA-Z0-9]\.[a-zA-Z0-9]{1,}([\.\-]{0,1}[a-zA-Z]){0,}[a-zA-Z0-9]{0,}$/i
    )



    if (!emailRegexp.test(value)) {

      return { email: true, message: 'E-mail inválido' };

    }

    return null;
  }

  static equals(anotherControlName: string, message?: string): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {

      const anotherControl = control.parent?.get(anotherControlName);


      if (anotherControl) {
        const { value } = control;

        if (!value) {
          return null;
        }

        if (anotherControl.touched && value !== anotherControl.value) {
          return { equals: true, message: message ?? 'O valor digitado não confere' };
        }

        if (anotherControl.invalid) {
          anotherControl.updateValueAndValidity();
        }
      }

      return null;
    }
  }

  static fullName(control: AbstractControl): ValidationErrors | null {
    const onlyLetters = FieldValidators.onlyLetters(control);
    if (onlyLetters) {
      return onlyLetters;
    }

    const { value } = control;

    if (!value) {
      return null;
    }

    if (typeof value !== "string" || value.trim().split(" ").filter(v => v.length > 1).length < 2) {
      return { fullName: true, message: 'Informe seu nome completo' };
    }

    return null;
  }

  static birthdate(control: AbstractControl): ValidationErrors | null {


    let date
    const { value } = control;

    if (value) {

      date = value.split('/')
      date = date[2] + '-' + date[1] + '-' + date[0]

    }




    if (!date) {

      return null;

    }

    date = new Date(date)

    if (date instanceof Date) {

      const age = ~~((Date.now() - +date) / (31557600000));


      if (age < PENAL_AGE || age > 150) {
        return { birthdate: true, message: 'Data de nascimento inválida' };
      }

    }

    return null;
  }

  static date(control: AbstractControl): ValidationErrors | null {


    let date
    const { value } = control;

    

    if (value) {

      date = value.split('/')
      date = date[2] + '-' + date[1] + '-' + date[0]


      var regex = /^\d{4}-\d{2}-\d{2}$/;

      if (!(regex.test(date))) {


         return {message: 'Data inválida' }

      }

    }

    if (!date) {

      return null;

    }

    

    return null;
  }

  static nationality(control: AbstractControl): ValidationErrors | null {
    const { value } = control;

    if (!value) {
      return null;
    }

    if (typeof value !== "string" || value.length < 6) {
      return { nationality: true, message: 'Nacionalidade inválida' };
    }

    return null;
  }

  static rg(control: AbstractControl): ValidationErrors | null {
    const { value } = control;

    if (!value) {
      return null;
    }

    if (typeof value !== "string" || value.length < 3) {
      return { rg: true, message: 'RG inválido' };
    }

    return null;
  }

  static armyPrecCp(control: AbstractControl): ValidationErrors | null {
    const { value } = control;

    if (!value) {
      return null;
    }

    if (typeof value !== "string" || value.length < 6) {
      return { armyPrecCp: true, message: 'PREC CP inválido!' };
    }

    return null;
  }

  static armyAuthorizationCode(anotherControlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const { value } = control;

      if (!value) {
        return null;
      }

      if (typeof value !== "string" || value.length < 6 || value.length > 8) {
        return { armyAuthorizationCode: true, message: 'Código deve possuir entre 6 e 8 caracteres' };
      }

      const anotherControl = control.parent?.get(anotherControlName);
      if (anotherControl) {
        if (anotherControl.touched && control.value === anotherControl.value) {
          return { armyAuthorizationCode: true, message: 'O código deve ser único' };
        }

        if (anotherControl.invalid) {
          anotherControl.updateValueAndValidity();
        }
      }

      return null;
    }
  }

  static siapeRegistration(control: AbstractControl): ValidationErrors | null {
    const { value } = control;

    if (!value) {
      return null;
    }

    if (typeof value !== "string" || value.length > 25) {
      return { siapeRegistration: true, message: 'Matrícula inválida!' };
    }

    return null;
  }

  static cpf(control: AbstractControl): ValidationErrors | null {



    const INVALID_NUMBERS = [
      '00000000000',
      '11111111111',
      '22222222222',
      '33333333333',
      '44444444444',
      '55555555555',
      '66666666666',
      '77777777777',
      '88888888888',
      '99999999999'
    ];

    const STRICT_STRIP_REGEX = /[.-]/g;
    const LOOSE_STRIP_REGEX = /[^\d]/g;

    const checkDigit = (digits: string): number => {
      const numbers = digits
        .split('')
        .map(number => parseInt(number, 10));

      const modulus = numbers.length + 1;
      const multiplied = numbers.map((number, index) => number * (modulus - index));
      const mod = multiplied.reduce((buffer, number) => buffer + number) % 11;

      return (mod < 2 ? 0 : 11 - mod);
    };

    const strip = (number: string, strict?: boolean): string => {
      const regex = strict ? STRICT_STRIP_REGEX : LOOSE_STRIP_REGEX;
      return (number || '').replace(regex, '');
    };

    const isValid = (number: string, strict?: boolean): boolean => {
      const stripped = strip(number, strict);

      if (!stripped) {
        return false;
      }

      if (stripped.length !== 11) {
        return false;
      }

      if (INVALID_NUMBERS.includes(stripped)) {
        return false;
      }

      let numbers = stripped.substring(0, 9);
      numbers += checkDigit(numbers);
      numbers += checkDigit(numbers);

      return numbers.substring(-2) === stripped.substring(-2);
    };

    const { value } = control;

    if (!value) {
      return null;
    }

    return typeof value === "string" && isValid(value) ? null : { cpf: true, message: 'CPF inválido' };



  }

  static password(control: AbstractControl): ValidationErrors | null {



    const { value } = control;


    let pass = value

    if (! /^(?=(?:.*?[a-zA-Z]){1})/.exec(pass)) {

      return { message: 'Informe no mínimo uma letra' };
    }

    if (! /^(?=(?:.*?[0-9]){1})/.exec(pass)) {

      return { message: 'Informe no mínimo um número' };

    }

    if (/^(?=(?:.*?[!@#$%*()_+^&}{:;?.]){1})(?!.*\s)[0-9a-zA-Z!@#;$%*(){}_+^&]/.exec(pass) && pass.length > 0) {

      return { message: 'Insira apenas letras e números' };

    }



    return null;


  }
}